<template>
  <div className="animated">
    <b-card class="animated fadeIn">
      <b-card-body>
        <h1>Stock de Materiales</h1>

        <b-row>
          <b-col cols="4">
            <b-form-group>
              <label>Material</label>
              <search-select v-model="selected.supply" :url="urlSearchSupply" />
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label="Exportadora(Dueño del material)">
              <search-select
                v-model="selected.client_customer"
                :url="urlSearchCompany"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <v-server-table
          :url="url"
          :columns="columns"
          :options="options"
          :theme="theme"
          ref="table"
          id="dataTable"
        >
          <template slot="afterFilter">
            <tr v-if="loading" class="VueTables__no-results">
              <b-spinner
                v-if="loading"
                variant="primary"
                class="ml-2 mt-1"
                small
                label="Small Spinner"
              ></b-spinner>
            </tr>
          </template>
          <template slot="quantity" slot-scope="props">
            <div class="text-right">{{ props.row.quantity.format() }}</div>
          </template>
          <div slot="beforeLimit">
            <download-excel
              class="btn"
              :fetch="fetchData"
              :fields="json_fields"
              worksheet="Recepcion"
              :name="name"
              :before-generate="startDownload"
              :before-finish="finishDownload"
            >
              <b-link>Descargar</b-link>
            </download-excel>
          </div>
        </v-server-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import Vue from "vue";
import { ServerTable, Event } from "vue-tables-2";
import JsonExcel from "vue-json-excel";
import moment from "moment";
import numeral from "numeral";
import locales from "numeral/locales";

numeral.locale("es");
window.axios = require("axios");

import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";
import searchSelect from "../reusable/searchSelect";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

var d = new Date();

Vue.use(ServerTable);
Vue.component("downloadExcel", JsonExcel);

export default {
  name: "Stock",
  components: {
    ServerTable,
    searchSelect
  },
  mounted() {
    Event.$on("vue-tables.loading", () => {
      this.loading = true;
    });

    Event.$on("vue-tables.loaded", () => {
      this.loading = false;
    });
  },
  data() {
    return {
      selected: {
        supply: null,
        client_customer: null
      },
      loading: false,
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      json_fields: {
        Exportadora: "client_customer",
        Material: "supply.name",
        Codigo: "supply.code",
        Cantidad: "quantity",
        Unidad: "supply.unit"
      },
      columns: [
        "client_customer",
        "supply.name",
        "supply.code",
        "quantity",
        "supply.unit"
      ],
      data: [],
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
      options: {
        debounce: 1000,
        responseAdapter: function (resp) {
          const results = resp.data.results;
          const items = [];
          for (let key in results) {
            const item = results[key];
            results[key].waybill_date = moment(
              results[key].waybill_date
            ).format("DD-MM-YYYY");
            results[key].quantity = numeral(parseFloat(results[key].quantity));
            items.push(item);
          }

          return {
            data: items,
            count: resp.data.count
          };
        },
        texts: {
          filter: "Filtrar:",
          filterBy: "Filtrar por {column}",
          count: " ",
          filterPlaceholder: "Buscar...",
          columns: "Columnas",
          limit: "Registros:"
        },
        filterByColumn: false,
        filterable: [],
        headings: {
          client_customer__name: "Exportadora",
          supply__name: "Material",
          supply__code: "Cod.",
          quantity: "Cantidad",
          supply__unit: "Unidad"
        },
        sortable: [],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          dropdown: false,
          chunk: 10
        }
      }
    };
  },
  computed: {
    name() {
      return (
        "Stock Materiales " +
        moment(Date.now()).format("YYYYMMDD h:mm") +
        ".xls"
      );
    },
    url() {
      var supply_id =
        this.selected.supply === null ? null : this.selected.supply.value;

      var client_customer_id =
        this.selected.client_customer === null
          ? null
          : this.selected.client_customer.id;

      return (
        "/api/supplies/waybill-supply/stock/?" +
        "&supply=" +
        supply_id +
        "&client_customer=" +
        client_customer_id
      );
    },
    urlSearchSupply: function () {
      return "/api/supplies/supply/select_search/";
    },
    urlSearchCompany: function () {
      return "/api/supplies/company/select_company/?type=2";
    }
  },
  methods: {
    async fetchData() {
      const response = await this.$axios.get(this.url);
      return response.data.results;
    },
    startDownload() {
      this.loading = true;
    },
    finishDownload() {
      this.loading = false;
    },

    getBadge(condition) {
      return condition === "Orgánico" ? "primary" : "success";
    }
  }
};
</script>

<style lang="scss">
#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }
  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
